// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.page-count {
  margin-bottom: 30px;
}
.page-count p {
  margin-bottom: 0;
  margin-top: 35px;
}

.inputCheckboxLabel {
  font-family: "Omnes-ATT-W02", Arial;
  font-size: 14px;
}

.fan-profile, .app-name {
  color: #0568ae !important;
  text-decoration: none;
}

.clearFix {
  padding-top: 30px;
}

.odd {
  background-color: hsl(0, 0%, 95%);
}
.odd .tablehiddendata .hiddenswitch > span {
  background: hsl(0, 0%, 95%);
}
.odd .tablehiddendata .hiddenswitch > div {
  background: hsl(0, 0%, 95%);
}

.search {
  padding-left: 0;
  padding-right: 0;
  position: relative;
  margin-top: -10px;
}
.search input {
  padding-right: 40px;
  font-family: "Omnes-ATT-W02";
}
.search .search-icon {
  margin-top: 5px;
  position: absolute;
  right: 5px;
  top: 50%;
}
.search #searchField::-ms-clear {
  display: none;
}

.searchBox-label {
  padding-bottom: 10px;
  font: 1.6rem "Omnes-ATT-W02-Medium";
}

.search-label {
  padding-bottom: 10px;
  font: 1.6rem "Omnes-ATT-W02-Medium";
}

.captionText {
  width: 47px;
  display: inline-block;
}

.captionText-hide {
  width: 0px !important;
}

.icon-arrows-sort-arrow {
  margin: 0 7px;
}
.icon-arrows-sort-arrow.down {
  margin: 0;
}
.icon-arrows-sort-arrow:before, .icon-arrows-sort-arrow:after {
  font-size: 13px;
  height: 11px;
}

.grid-table {
  word-break: break-word;
}

tr a,
thead a {
  color: #191919;
}
tr a.sort-label,
thead a.sort-label {
  color: hsl(204.9, 94.4%, 35.1%);
}
tr td,
thead td {
  border-left: 1px solid #d2d2d2;
}
tr:last-child td,
thead:last-child td {
  border-bottom: 1px solid #d2d2d2;
}

table td:first-child,
tbody td:first-child {
  border-left: 0;
}

.table {
  margin-bottom: 20px;
  table-layout: fixed;
}
.table td {
  word-wrap: break-word;
}

.pagination {
  margin-bottom: 20px;
}

.go-label input {
  height: 36px;
  margin-left: 5px;
  margin-right: 5px;
  width: 40px;
}
.go-label label {
  margin-top: 13px;
}

.checkbox .skin {
  box-sizing: unset;
}

.checkbox,
.radio {
  display: inline-block;
}

@media (max-width: 1024px) {
  .search-label {
    font: 1.4rem "Omnes-ATT-W02-Medium";
  }
  .table {
    table-layout: initial;
  }
  .clear-search-link {
    padding: 0 15px;
    text-align: left;
  }
  .search-group {
    padding-top: 80px;
    margin-bottom: 20px;
  }
}
.tablehiddendata {
  background-image: url('data:image/svg+xml,<svg%20xmlns%3D"http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg"%20version%3D"1.1"%20viewport%3D"0%200%201%201"%20style%3D"width%3A100%25%3B%20height%3A1px%3B"><style>line%7Bstroke%3Argba(153%2C153%2C153%2C1)%3Bstroke-width%3A2%3B%7D<%2Fstyle><line%20y2%3D"1"%20y1%3D"1"%20x1%3D"1"%20x2%3D"100%25"%20stroke-dasharray%3D"1%2C%203"%2F><%2Fsvg>') !important;
  background-position: left 13px;
  background-repeat: repeat-x;
  background-size: 4px 1px;
  margin: 0;
}
.tablehiddendata .hiddenswitch > span {
  background: white;
  float: left;
  font-family: "Omnes-ATT-W02-Medium";
  padding-right: 7px;
}
.tablehiddendata .hiddenswitch > div {
  background: white;
  float: right;
  padding-left: 7px;
}

.openhiddenrow {
  border-bottom: 2px solid #ccc;
  border-top: 2px solid #ccc;
}
.openhiddenrow th {
  border: 0;
}
.openhiddenrow td {
  border: 0;
}

.rowdisabled {
  cursor: block;
  opacity: 1;
}

input[disabled] + .skin {
  background-color: #d2d2d2;
}

.contentStyle a {
  color: #191919;
}

.tooltip-input {
  right: -7px !important;
  bottom: 11px !important;
  width: 30px;
}
@media (max-width: 1024px) {
  .tooltip-input {
    right: -7px !important;
    bottom: 11px !important;
    width: 20px;
  }
}
@media (max-width: 980px) and (min-width: 400px) {
  .tooltip-input {
    right: -7px !important;
    bottom: 11px !important;
    width: 20px;
  }
}
@media screen and (min-device-width: 375px) and (max-device-width: 667px) {
  .tooltip-input {
    right: -7px !important;
    bottom: 11px !important;
    width: 20px;
  }
}
@media screen and (min-device-width: 414px) and (max-device-width: 736px) {
  .tooltip-input {
    right: -7px !important;
    bottom: 11px !important;
    width: 20px;
  }
}
@media (max-width: 1024px) {
  .tooltip-input {
    right: -200px;
    bottom: -5px;
    width: 20px;
  }
}

.legend-container {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.legend-label {
  font-weight: bold;
  margin-right: 5px;
  top: -18px;
  padding: 20px;
  color: white;
  position: relative;
}

.legend-tooltip {
  cursor: pointer;
  display: inline-block;
}

.legend-content {
  position: absolute;
  top: 96%;
  left: -419px;
  background-color: #f9f9f9;
  border: 1px solid;
  padding: 10px;
  font-size: 12px;
  line-height: 1.5;
  width: 498px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: none;
  z-index: 1000;
  border-radius: 6px;
}

.legend-container:hover .legend-content {
  display: block; /* Show tooltip on hover */
}

.legend-container:hover .legend-content,
.legend-container:focus-within .legend-content {
  display: block;
}

.left-tooltip::before {
  content: "";
  position: absolute;
  top: 50%;
  right: -10px; /* Adjust for arrow placement */
  transform: translateY(-50%);
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent transparent #ccc; /* Arrow pointing left */
}

.no-border {
  border: none !important;
}

.checkbox-alignment {
  padding-left: 30px;
  float: left;
}
@media (max-width: 1024px) {
  .checkbox-alignment {
    padding-left: 0px;
  }
}

.align-fans {
  padding-left: 42px;
}
@media (max-width: 1024px) {
  .align-fans {
    padding-left: 0px;
  }
}

.table-header {
  white-space: nowrap;
  width: 280px;
  max-width: 300px;
}

.tooltipActive + .appleDEP-text {
  top: 61% !important;
  left: 28% !important;
  height: 100px !important;
}
@media (max-width: 1024px) {
  .tooltipActive + .appleDEP-text {
    height: 110px !important;
    margin-top: -1% !important;
  }
}

.tooltipActive + .appleDEP-content {
  top: 58% !important;
}

.align-tooltip {
  display: inline-flex;
  align-items: center;
}
.align-tooltip p {
  margin: 0;
  padding: 0;
  display: inline;
  line-height: 1.5;
}
@media (max-width: 1024px) {
  .align-tooltip .tooltip-abm {
    margin-top: 10% !important;
    left: -22% !important;
  }
}
.align-tooltip .tooltip-icon {
  margin: 0;
  padding: 0;
  vertical-align: middle;
  right: 40%;
  top: 9px !important;
}
@media (max-width: 1024px) {
  .align-tooltip .tooltip-icon {
    right: 3%;
    top: 19px !important;
  }
}

.tooltipActive + .helperText-kme {
  top: 55% !important;
}

.tooltipActive + .helperText-abm {
  top: 58.5% !important;
}
@media (max-width: 1024px) {
  .tooltipActive + .helperText-abm {
    top: 62% !important;
  }
}

.tooltipActive + .tooltip-texts {
  top: 63% !important;
}

.tooltipActive + .helper-text {
  padding: 10px;
  display: inline-block;
  position: absolute;
  width: 280px !important;
  font-size: 11px;
  border-radius: 7px;
  background-color: white;
  border: 1px solid var(--Controls-Border-Floating, #DCDFE3);
  box-shadow: 0px 2px 8px 0px rgba(37, 48, 58, 0.1215686275);
  display: inline-table;
  bottom: 100%;
  margin-left: 0px !important;
  margin-bottom: -2px;
  background-color: white;
  color: black;
  top: 51.5%;
  left: 65%;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-width: 100%;
  display: block;
  height: 70px;
  cursor: pointer;
  font-family: "Omnes-ATT-W02", Arial !important;
}
@media (max-width: 1024px) {
  .tooltipActive + .helper-text {
    margin-left: -170px;
    margin-bottom: -2px;
    left: 18px !important;
    background-color: white;
    top: 57.5% !important;
  }
}
@media (max-width: 1024px) {
  .tooltipActive + .helper-text {
    z-index: 1;
    margin-top: 0px;
    margin-left: -123px;
  }
}

@media (max-width: 1024px) {
  .mobile-header {
    padding-left: 30px;
  }
  .accountHeader {
    position: relative;
    left: -50px;
  }
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/lib/ng2-sapmp/src/ui-components/custom-grid/customgrid.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAjJA;EACE,mBAAA;AAmJF;AAjJE;EACE,gBAAA;EACA,gBAAA;AAmJJ;;AA/IA;EACE,mCAAA;EACD,eAAA;AAkJD;;AA/IA;EACI,yBAAA;EACA,qBAAA;AAkJJ;;AA/IA;EACE,iBAAA;AAkJF;;AA/IA;EACE,iCAAA;AAkJF;AA7IM;EACE,2BAAA;AA+IR;AA5IM;EACE,2BAAA;AA8IR;;AAvIA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AA0IF;AAxIE;EACE,mBAAA;EACA,4BAAA;AA0IJ;AAvIE;EACE,eAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;AAyIJ;AAtIE;EACE,aAAA;AAwIJ;;AArIA;EACE,oBAAA;EACA,mCAAA;AAwIF;;AAtIA;EACE,oBAAA;EACA,mCAAA;AAyIF;;AAvIA;EACE,WAAA;EACA,qBAAA;AA0IF;;AAxIA;EACE,qBAAA;AA2IF;;AAxIA;EACE,aAAA;AA2IF;AAzIE;EACE,SAAA;AA2IJ;AAzIE;EACE,eAAA;EACA,YAAA;AA2IJ;;AAxIA;EACE,sBAAA;AA2IF;;AAtIE;;EACE,cAAA;AA0IJ;AAzII;;EACE,+BAAA;AA4IN;AAxIE;;EACE,8BAAA;AA2IJ;AAvII;;EACE,gCAAA;AA0IN;;AAnIE;;EACE,cAAA;AAuIJ;;AAnIA;EACE,mBAAA;EACA,mBAAA;AAsIF;AApIE;EACE,qBAAA;AAsIJ;;AAlIA;EACE,mBAAA;AAqIF;;AAhIE;EACE,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;AAmIJ;AAhIE;EACE,gBAAA;AAkIJ;;AA/HA;EACE,iBAAA;AAkIF;;AAhIA;;EAEE,qBAAA;AAmIF;;AFrQI;EEsIF;IACE,mCAAA;EAmIF;EAhIA;IACE,qBAAA;EAkIF;EA/HA;IACE,eAAA;IACA,gBAAA;EAiIF;EA9HA;IACE,iBAAA;IACA,mBAAA;EAgIF;AACF;AA7HA;EACE,iYAAA;EACA,8BAAA;EACA,2BAAA;EACA,wBAAA;EACA,SAAA;AA+HF;AA5HI;EACE,iBAAA;EACA,WAAA;EACA,mCAAA;EACA,kBAAA;AA8HN;AA3HI;EACE,iBAAA;EACA,YAAA;EACA,iBAAA;AA6HN;;AAxHA;EACE,6BAAA;EACA,0BAAA;AA2HF;AAzHE;EACE,SAAA;AA2HJ;AAxHE;EACE,SAAA;AA0HJ;;AAtHA;EACE,aAAA;EACA,UAAA;AAyHF;;AAtHA;EACE,yBAAA;AAyHF;;AArHE;EACE,cAAA;AAwHJ;;AApHA;EACE,sBAAA;EACA,uBAAA;EACD,WAAA;AAuHD;AFtUI;EE4MJ;IAMG,sBAAA;IACD,uBAAA;IACG,WAAA;EAwHH;AACF;AAvHC;EAVD;IAWG,sBAAA;IACA,uBAAA;IACE,WAAA;EA0HH;AACF;AAzHC;EAfD;IAgBG,sBAAA;IACA,uBAAA;IACE,WAAA;EA4HH;AACF;AA3HG;EApBH;IAqBK,sBAAA;IACA,uBAAA;IACA,WAAA;EA8HH;AACF;AA7HG;EAzBH;IA0BK,aAAA;IACA,YAAA;IACA,WAAA;EAgIH;AACF;;AA5HA;EACE,kBAAA;EACA,qBAAA;EACA,eAAA;AA+HF;;AA5HA;EACE,iBAAA;EACA,iBAAA;EACA,UAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;AA+HF;;AA5HA;EACE,eAAA;EACA,qBAAA;AA+HF;;AAjHA;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EAEA,yBAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EAEA,wCAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;AAkHF;;AA/GA;EACE,cAAA,EAAA,0BAAA;AAkHF;;AA/GA;;EAEE,cAAA;AAkHF;;AA/GA;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA,EAAA,+BAAA;EACA,2BAAA;EACA,iBAAA;EACA,mBAAA;EACA,sDAAA,EAAA,wBAAA;AAkHF;;AA/GA;EACE,uBAAA;AAkHF;;AA/GA;EACE,kBAAA;EACA,WAAA;AAkHF;AF1aI;EEsTJ;IAKI,iBAAA;EAmHF;AACF;;AAhHA;EACE,kBAAA;AAmHF;AFnbI;EE+TJ;IAKI,iBAAA;EAmHF;AACF;;AAhHA;EACE,mBAAA;EACA,YAAA;EACA,gBAAA;AAmHF;;AApGA;EACE,mBAAA;EACA,oBAAA;EACA,wBAAA;AAuGF;AFpcI;EE0VJ;IAKI,wBAAA;IACA,0BAAA;EAyGF;AACF;;AAtGA;EACE,mBAAA;AAyGF;;AAtGA;EACE,oBAAA;EACA,mBAAA;AAyGF;AAvGE;EACI,SAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;AAyGN;AFzdI;EEoXA;IACE,0BAAA;IACA,qBAAA;EAwGJ;AACF;AArGE;EACI,SAAA;EACA,UAAA;EACA,sBAAA;EACA,UAAA;EACA,mBAAA;AAuGN;AFteI;EE0XF;IAOM,SAAA;IACA,oBAAA;EAyGN;AACF;;AApGA;EACE,mBAAA;AAuGF;;AApGA;EACE,qBAAA;AAuGF;AFpfI;EE4YJ;IAGI,mBAAA;EAyGF;AACF;;AAtGA;EACE,mBAAA;AAyGF;;AArGA;EACE,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;EACA,0DAAA;EACA,0DAAA;EACA,qBAAA;EACA,YAAA;EACA,2BAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,8CAAA;AAwGF;AFzhBI;EEwZJ;IA6BM,mBAAA;IACA,mBAAA;IACA,qBAAA;IACA,uBAAA;IACA,qBAAA;EAwGJ;AACF;AAtGE;EApCF;IAqCI,UAAA;IAEA,eAAA;IACA,mBAAA;EAwGF;AACF;;AFziBI;EEqcF;IACE,kBAAA;EAwGF;EAtGA;IACE,kBAAA;IACA,WAAA;EAwGF;AACF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../assets/style/mixinfunction';\n\n.page-count {\n  margin-bottom: 30px;\n\n  p {\n    margin-bottom: 0;\n    margin-top: 35px;\n  }\n}\n\n.inputCheckboxLabel{\n  font-family: 'Omnes-ATT-W02', Arial;\n\tfont-size: 14px;\n}\n\n.fan-profile, .app-name{\n    color: #0568ae !important;\n    text-decoration: none;\n}\n\n.clearFix{\n  padding-top: 30px;\n}\n\n.odd {\n  background-color: color(default, base);\n\n  \n   .tablehiddendata{\n    .hiddenswitch {\n      & > span {\n        background: color(default, base);\n        }\n\n      & > div {\n        background: color(default, base);\n        }\n      }\n   }\n\n}\n\n.search  {\n  padding-left: 0;\n  padding-right: 0;\n  position: relative;\n  margin-top: -10px;\n\n  input {\n    padding-right: 40px;\n    font-family: 'Omnes-ATT-W02';\n  }\n\n  .search-icon {\n    margin-top: 5px;\n    position: absolute;\n    right: 5px;\n    top: 50%;\n  }\n\n  #searchField::-ms-clear{\n    display:none;\n  }\n}\n.searchBox-label{\n  padding-bottom: 10px;\n  font: 1.6rem 'Omnes-ATT-W02-Medium';\n}\n.search-label {\n  padding-bottom: 10px;\n  font: 1.6rem 'Omnes-ATT-W02-Medium';\n}\n.captionText {\n  width: 47px;\n  display: inline-block;\n}\n.captionText-hide {\n  width: 0px !important;\n}\n\n.icon-arrows-sort-arrow {\n  margin: 0 7px;\n\n  &.down {\n    margin: 0;\n  }\n  &:before, &:after {\n    font-size: 13px;\n    height: 11px;  \n  }\n}\n.grid-table {\n  word-break: break-word;\n}\n\ntr,\nthead {\n  a {\n    color: color(inverse, darker);\n    &.sort-label {\n      color: color(secondary,base);\n    }\n  }\n\n  td {\n    border-left: 1px solid color(default, dark);\n  }\n\n  &:last-child {\n    td {\n      border-bottom: 1px solid color(default, dark);\n    }\n  }\n}\n\ntable,\ntbody {\n  td:first-child {\n    border-left: 0;\n  }\n}\n\n.table {\n  margin-bottom: 20px;\n  table-layout: fixed;\n\n  td {\n    word-wrap: break-word;\n  }\n}\n\n.pagination {\n  margin-bottom: 20px;\n}\n\n.go-label {\n\n  input {\n    height: 36px;\n    margin-left: 5px;\n    margin-right: 5px;\n    width: 40px;\n  }\n\n  label {\n    margin-top: 13px;\n  }\n}\n.checkbox .skin{\n  box-sizing: unset;\n}\n.checkbox,\n.radio {\n  display: inline-block;\n}\n@include respond-to(small) {\n\n  .search-label {\n    font: 1.4rem 'Omnes-ATT-W02-Medium';\n  }\n\n  .table {\n    table-layout: initial;\n  }\n\n  .clear-search-link {\n    padding: 0 15px;\n    text-align: left;\n  }\n\n  .search-group {\n    padding-top: 80px;\n    margin-bottom: 20px;\n  }\n}\n\n.tablehiddendata {\n  background-image: url('data:image/svg+xml,<svg%20xmlns%3D\"http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg\"%20version%3D\"1.1\"%20viewport%3D\"0%200%201%201\"%20style%3D\"width%3A100%25%3B%20height%3A1px%3B\"><style>line%7Bstroke%3Argba(153%2C153%2C153%2C1)%3Bstroke-width%3A2%3B%7D<%2Fstyle><line%20y2%3D\"1\"%20y1%3D\"1\"%20x1%3D\"1\"%20x2%3D\"100%25\"%20stroke-dasharray%3D\"1%2C%203\"%2F><%2Fsvg>') !important;\n  background-position: left 13px;\n  background-repeat: repeat-x;\n  background-size: 4px 1px;\n  margin: 0;\n\n  .hiddenswitch {\n    & > span {\n      background: color(default, light);\n      float: left;\n      font-family: 'Omnes-ATT-W02-Medium';\n      padding-right: 7px;\n      }\n\n    & > div {\n      background: color(default, light);\n      float: right;\n      padding-left: 7px;\n      }\n    }\n}\n\n.openhiddenrow {\n  border-bottom: 2px solid #ccc;\n  border-top: 2px solid #ccc;\n\n  th {\n    border: 0;\n    }\n\n  td {\n    border: 0;\n    }\n}\n\n.rowdisabled {\n  cursor: block;\n  opacity: 1;\n}\n\ninput[disabled]+.skin {\n  background-color: color(default, dark);\n}\n\n.contentStyle {\n  a {\n    color: color(inverse, darker);\n  }\n}\n\n.tooltip-input {\n  right: -7px !important;\n  bottom: 11px !important;\n width: 30px;\n\n @include respond-to('small') {\n   right: -7px !important;\n  bottom: 11px !important;\n     width: 20px;\n }\n @media(max-width: 980px) and (min-width:400px) {\n   right: -7px !important;\n   bottom: 11px !important;\n     width: 20px;\n }\n @media screen and (min-device-width : 375px) and (max-device-width : 667px) {\n   right: -7px !important;\n   bottom: 11px !important;\n     width: 20px;\n   }\n   @media screen and (min-device-width : 414px) and (max-device-width : 736px) {\n     right: -7px !important;\n     bottom: 11px !important;\n     width: 20px;\n   }\n   @media(max-width: 1024px) {\n     right: -200px ;\n     bottom: -5px;\n     width: 20px;\n   }\n  \n}\n\n.legend-container {\n  position: relative;\n  display: inline-block;\n  cursor: pointer;\n}\n\n.legend-label {\n  font-weight: bold;\n  margin-right: 5px;\n  top: -18px;\n  padding: 20px;\n  color: white;\n  position: relative;\n}\n\n.legend-tooltip {\n  cursor: pointer;\n  display: inline-block;\n}\n\n// .legend-content {\n//   display: none;\n//   position: absolute;\n//   background-color: #fff;\n//   border: 1px solid #ccc;\n//   padding: 10px;\n//   z-index: 1000;\n//   width: 300px;\n//   box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n// }\n\n.legend-content {\n  position: absolute;\n  top: 96%;\n  left: -419px; \n  // transform: translateY(-50%);\n  background-color: #f9f9f9;\n  border: 1px solid;\n  padding: 10px;\n  font-size: 12px;\n  line-height: 1.5;\n  width: 498px;\n  // max-width: 300px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  display: none; \n  z-index: 1000;\n  border-radius: 6px;\n}\n\n.legend-container:hover .legend-content {\n  display: block; /* Show tooltip on hover */\n}\n\n.legend-container:hover .legend-content,\n.legend-container:focus-within .legend-content {\n  display: block;\n}\n\n.left-tooltip::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  right: -10px; /* Adjust for arrow placement */\n  transform: translateY(-50%);\n  border-width: 5px;\n  border-style: solid;\n  border-color: transparent transparent transparent #ccc; /* Arrow pointing left */\n}\n\n.no-border {\n  border: none !important;\n}\n\n.checkbox-alignment {\n  padding-left: 30px;\n  float: left;\n\n  @include respond-to('small') {\n    padding-left: 0px;\n}\n}\n\n.align-fans {\n  padding-left: 42px;\n  // float: left;\n\n  @include respond-to('small') {\n    padding-left: 0px;\n  }\n}\n\n.table-header {\n  white-space: nowrap;\n  width: 280px;\n  max-width: 300px;\n}\n\n\n// .table td:first-child {\n//   width: 40px;\n//   padding-left: 15px;\n// }\n\n// .table td:nth-child(2) {\n//   width: 150px;\n//   float: left;\n//   padding-top: 13px;\n// }\n\n.tooltipActive + .appleDEP-text {\n  top: 61% !important;\n  left: 28% !important;\n  height: 100px !important;\n  @include respond-to('small') {\n    height: 110px !important;\n    margin-top: -1% !important;\n  }\n}\n\n.tooltipActive + .appleDEP-content {\n  top: 58% !important;\n}\n\n.align-tooltip {\n  display: inline-flex;\n  align-items: center;\n\n  p {\n      margin: 0;\n      padding: 0;\n      display: inline;\n      line-height: 1.5; \n  }\n\n  @include respond-to (small){\n    .tooltip-abm {\n      margin-top: 10% !important;\n      left: -22% !important;\n    }\n  }\n\n  .tooltip-icon {\n      margin: 0; \n      padding: 0; \n      vertical-align: middle;\n      right: 40%; \n      top: 9px !important;\n      @include respond-to (small){\n        right: 3%;\n        top: 19px !important;\n      }\n  }\n}\n\n\n.tooltipActive + .helperText-kme {\n  top: 55% !important;\n}\n\n.tooltipActive + .helperText-abm {\n  top: 58.5% !important;\n  @include respond-to('small') {\n    top: 62% !important;\n  }\n}\n\n.tooltipActive + .tooltip-texts {\n  top: 63% !important;\n}\n\n\n.tooltipActive + .helper-text {\n  padding: 10px;\n  display: inline-block;\n  position: absolute;\n  width: 280px !important;\n  font-size: 11px;\n  border-radius: 7px;\n  background-color: white;\n  border: 1px solid var(--Controls-Border-Floating, #DCDFE3);\n  box-shadow: 0px 2px 8px 0px rgba(37, 48, 58, 0.1215686275);\n  display: inline-table;\n  bottom: 100%;\n  margin-left: 0px !important;\n  margin-bottom: -2px;\n  background-color: white;\n  color: black;\n  top: 51.5%;\n  left: 65%;\n  white-space: normal; \n  word-wrap: break-word; \n  overflow-wrap: break-word; \n  max-width: 100%; \n  display: block;\n  height: 70px;\n  cursor: pointer;\n  font-family: \"Omnes-ATT-W02\", Arial !important;\n  @include respond-to('small') {\n      //width: fit-content;\n      // margin-top:0px;\n      margin-left: -170px;\n      margin-bottom: -2px;\n      left: 18px !important;\n      background-color: white;\n      top: 57.5% !important;\n  }\n\n  @media(max-width: 1024px) {\n    z-index: 1;\n    // width: 105px;\n    margin-top:0px;\n    margin-left: -123px;\n}\n}\n\n@include respond-to('small') {\n  .mobile-header {\n    padding-left: 30px;\n  }\n  .accountHeader {\n    position: relative;\n    left: -50px\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
